// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"89507b5f","239":"ad40150f","455":"9806cc50","918":"25c3ee2f","977":"6a7f6471"}[chunkId] + ".chunk.js";
};